import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ModuloTypes } from '../../../../@types/entities/modulo.entity';
import Theme from '../../../../design-system/Theme';
import getModulesType from '../../../../utils/get-Modules-Types';

const newTheme = new Theme();
const { mobile, tablet } = newTheme.breakpoints;

export const StyledImage = styled.img`
  width: 280px;
  height: auto;

  @media (min-width: ${tablet}) {
    width: 130px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 8px 0;
  background: #fff;
  align-items: center;
  min-height: 15dvh;

  @media (min-width: ${tablet}) {
    flex-direction: row;
    justify-content: space-between;
    padding: 16px 40px;
  }

  @media (max-width: ${tablet}) {
    width: 100%;
    align-self: center;
  }

  @media (min-width: calc(${tablet} + 1px)) {
    width: 100%;
    margin: 0 auto;
    padding: 14px 0 20px 0;
    min-height: 20dvh;
  }
`;

export const Box = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  grid-template-areas: 
    "ftd . . faca-bonito"
    "disclaimer disclaimer disclaimer disclaimer";
  padding: 0 16px;

  @media (min-width: 1000px) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    grid-template-areas: 
      "ftd faca-bonito"
      "disclaimer disclaimer";
    width: 1000px;
    margin: 0 auto;
  }

  .ftd-logo p {
    display: none;

    @media (min-width: 600px) {
      display: block;
    }
  }

  .ftd-logo {
    grid-area: ftd;
    display: flex;
    align-items: center;
  }

  & img:first-child {
    width: 51px;

    @media (min-width: 600px) {
      width: 90px;
    }

    height: auto;
    align-self: center;
  }

  & img:nth-child(3) {
    grid-area: faca-bonito;
    width: 34px;
    @media (min-width: 600px) {
      width: 60px;
    }
    height: auto;
    justify-self: end;
  }

  .disclaimer {
    grid-area: disclaimer;
    text-align: center;
    margin: 0 auto;
    font-size: 0.75rem;
    color: #aaaaaa;
    font-family: "Open Sans", sans-serif;

    @media (min-width: 600px) {
      font-size: 0.9rem;
      border-top: 1px solid #D6D6D6;
      text-align: left;
      margin: unset;
      padding-top: 12px;
    }
  }

  & > p {
    @media (min-width: 600px) {
      display: none;
    }
  }
`;
